import { Link, useNavigate } from 'react-router-dom'
import { Heart, LogOut, User, Moon, Sun } from 'lucide-react'
import { useState, useEffect } from 'react'
import { toggleTheme, getCurrentTheme } from '../utils/themeManager'
import styles from './Header.module.css'

export default function Header() {
    const token = localStorage.getItem('token')
    const publicName = localStorage.getItem('publicName') || localStorage.getItem('username') || 'Bruger'
    const navigate = useNavigate()
    const [isDark, setIsDark] = useState(false)

    useEffect(() => {
        // Initialize theme state
        setIsDark(getCurrentTheme() === 'dark')

        // Listen for theme changes
        const updateTheme = () => {
            setIsDark(getCurrentTheme() === 'dark')
        }

        window.addEventListener('storage', updateTheme)
        return () => window.removeEventListener('storage', updateTheme)
    }, [])

    const handleThemeToggle = () => {
        toggleTheme()
        setIsDark(getCurrentTheme() === 'dark')
    }

    const handleLogout = () => {
    localStorage.removeItem('token')
    localStorage.removeItem('role')
    localStorage.removeItem('publicName')
    window.dispatchEvent(new Event('auth-changed'))
    navigate('/', { replace: true })
    }

    return (
        <header className={styles.header}>
            <div className={styles.inner}>
                <div className={styles.left}>
                    <Link to="/" className={styles.logo}>
                        <img src="/Astma_Allergi_Shoppen_Logo_Sort.avif" alt="Astma Allergi Shoppen Logo" style={{ height: 40, width: 'auto', display: 'block' }} />
                    </Link>
                </div>

                <nav className={styles.center}>
                    <Link to="/funktioner" style={{ marginRight: 16 }}>Se funktioner</Link>
                    <Link to="/OmOs">Om os</Link>
                </nav>

                <div className={styles.right}>
                    <button
                        onClick={handleThemeToggle}
                        className={styles.themeToggle}
                        title={isDark ? 'Skift til lyst tema' : 'Skift til mørkt tema'}
                    >
                        {isDark ? <Sun size={18} /> : <Moon size={18} />}
                    </button>
                    {token ? (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                            <Link to="/profile" className={styles.profileBtn} title="Profil" style={{ display: 'flex', alignItems: 'center', gap: '0.4rem', padding: '0.4rem 0.8rem', borderRadius: '999px' }}>
                                <User size={16} />
                                {publicName}
                            </Link>
                            <button
                                onClick={handleLogout}
                                className={styles.logoutBtn}
                                title="Log ud"
                                style={{ display: 'flex', alignItems: 'center', gap: '0.4rem' }}
                            >
                                <LogOut size={18} />
                                Log ud
                            </button>
                        </div>
                    ) : (
                        <div className={styles.authButtons}>
                            <Link to="/login" className={styles.loginBtn}>Log ind</Link>
                            <Link to="/signup" className={styles.ctaBtn}>Start gratis prøveperiode</Link>
                        </div>
                    )}
                </div>
            </div>
        </header>

    )
}
